import {throttle} from "alpinejs/src/utils/throttle";

const psnNavigation =  (template) => ({
  mainContainer: null,
  mainContainerWidth: null,
  showMegaMenu: false,
  selectedHandle: null,
  selectedItem: null,
  showMobileMenu: false,
  selectedMobileHandle: null,
  showSubMenu: false,
  showThirdLevelSubMenu: false,
  body: null,
  selectedThirdLevelMobileHandle: null,
  selectedThirdLevelMobileParentHandle: null,
  menuInner: null,
  headerHeight: null,
  announcementBar: null,
  announcementBarHeight: 0,
  headerGroup: null,
  scrollUp: "",
  scrollDown: "",
  lastScroll: 0,
  topPosition: 0,
  megaMenuOverlay: null,
  mobileMenuWrapper: null,
  mobileOverlay: null,
  mobileMenuBottomPanel: null,
  pageTemplate: null,
  backgroundIsTransparent: true,
  navigationItems: null,
  OpenSearch: false,
  searchInput: null,
  selectedMegaMenu: null,
  selectedMegaMenuHandle: null,
  selectedCollectionImage: null,
  isHeaderTransparent: false,
  isMobileHeaderTransparent: false,
  isCollectionMobileHeaderTransparent: false,
  hideSearchbarMobile: false,
  isIndexPage: false,
  mobileSearchVisible: false,
  isOpeningMobileSearch: false,
  lastWindowHeight: null,
  resizeTimeout: null,
  init() {
    this.mainContainer = document.querySelector("main")
    this.pageTemplate = this.mainContainer.getAttribute("data-template")

    this.scrollUp = "scroll-up"
    this.scrollDown = "scroll-down"
    this.announcementBar = document.querySelector(".announcement-bar")
    this.headerGroup = document.querySelector(".header-group")
    this.megaMenuOverlay = document.querySelector('.megamenu-overlay')
    this.mobileMenuWrapper = document.querySelectorAll('.mobile-menu__wrapper')
    this.mobileOverlay = document.querySelector('.mobile-overlay')
    this.mobileMenuBottomPanel = document.querySelector('.mobile-menu__bottom-panel')
    this.searchInput = document.getElementById('Search-In-Modal')

    this.navigationItems = document.querySelectorAll(".navigation-item")

    // Initialize mobile search visibility
    this.initMobileSearch()

    if (this.announcementBar){
      this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0
    }

    this.body = document.querySelector("html body")
    this.menuInner = document.querySelectorAll(".js-mega-menu_inner")

    setTimeout(()=>{
      if (this.pageTemplate !== "index" && !this.isHeaderTransparent){
        this.setMainContainerMargin();
      }else {
        this.mainContainer.style.paddingTop = '0'
      }

      if (!this.isMobileHeaderTransparent && this.isHeaderTransparent && this.pageTemplate !== "index"){

        const updateMainContainerMargin = () => {
          if (window.innerWidth <= 989) {

            if (!this.isMobileHeaderTransparent && this.pageTemplate === "collection") {
                  this.isCollectionMobileHeaderTransparent = true
            }


            this.setMainContainerMargin();
          } else {
            this.mainContainer.style.paddingTop = '0';
            this.isCollectionMobileHeaderTransparent = false
          }
        };

        updateMainContainerMargin();

        window.addEventListener("resize", updateMainContainerMargin);
      }
      this.setHeaderVariables();
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.mainContainer.classList.add('psn-padding-transition')
        })
      })
    }, 0)

    setTimeout(()=>{
      this.topPosition = Math.ceil(this.headerGroup.getBoundingClientRect().bottom)
      this.calculateHeaderWidth()
      /*this.setMegaMenuTopPosition()*/
      //this.setMobileMenuTopPosition()
    }, 300)

    if (this.announcementBarHeight){
      this.announcementBar.style.transform = `translateY(0)`
      this.headerGroup.style.transform = `translateY(${this.announcementBarHeight}px)`
    }

    this.backgroundIsTransparent = window.pageYOffset <= this.announcementBarHeight;
    this.lastWindowHeight = window.innerHeight

    window.addEventListener("resize", () => {
      // On Android, keyboard opening triggers resize events
      // Detect if this is a keyboard resize (small height change on mobile)
      const currentHeight = window.innerHeight
      const heightDiff = Math.abs(this.lastWindowHeight - currentHeight)
      const isMobile = window.innerWidth <= 989
      const searchInput = document.getElementById('Search-In-Modal')
      const isInputFocused = searchInput && document.activeElement === searchInput
      
      // If on mobile and input is focused, this is likely a keyboard resize
      // Don't run heavy operations that might cause blur
      const isKeyboardResize = isMobile && isInputFocused && heightDiff < 300 && heightDiff > 50
      
      this.headerHeight = this.headerGroup.offsetHeight
      setTimeout(()=>{
        this.topPosition = Math.ceil(this.headerGroup.getBoundingClientRect().bottom)
        /*this.setMegaMenuTopPosition()*/
      }, 300)

      this.calculateHeaderWidth()
      this.setMainSectionPaddingTopConditionally(this.headerHeight)
      
      // Only re-initialize mobile search on resize if it's NOT a keyboard resize
      // This prevents the input from losing focus when keyboard opens on Android
      // Note: Visibility is now handled by CSS, so we only update state if needed
      if (!isKeyboardResize) {
        // Debounce to avoid multiple calls
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout)
        }
        this.resizeTimeout = setTimeout(() => {
          // Just update the state, CSS handles visibility
          const mobileSearchContainer = document.getElementById('mobile-search-container')
          if (mobileSearchContainer && window.innerWidth <= 989) {
            const hideSetting = mobileSearchContainer.getAttribute('data-hide-searchbar-mobile') === 'true'
            const template = mobileSearchContainer.getAttribute('data-template-name')
            const isHidden = mobileSearchContainer.getAttribute('data-mobile-search-hidden') === 'true'
            this.mobileSearchVisible = !hideSetting || template === 'index' || !isHidden
          }
        }, 100)
      }
      
      this.lastWindowHeight = currentHeight
    })

    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset
      this.backgroundIsTransparent = currentScroll <= this.announcementBarHeight;

      if (currentScroll > this.announcementBarHeight && currentScroll > this.lastScroll && !this.body.classList.contains(this.scrollDown)) {
        this.body.classList.remove(this.scrollUp)
        this.body.classList.add(this.scrollDown)
        if (this.announcementBar){
          this.announcementBar.style.transform = this.announcementBar ? `translateY(-${this.announcementBarHeight}px)` : 'translateY(0)'
        }

        this.setHeaderVariables(true);

        this.headerGroup.style.transform = 'translateY(0)'
        this.setMainSectionPaddingTopConditionally(this.headerGroup.offsetHeight)
      }

      if (currentScroll < this.lastScroll && this.body.classList.contains(this.scrollDown)) {
        this.body.classList.remove(this.scrollDown)
        this.body.classList.add(this.scrollUp)

        if (this.announcementBar){
          this.announcementBar.style.transform = 'translateY(0)'
        }

        this.headerGroup.style.transform = `translateY(${this.announcementBarHeight}px)`
        this.setHeaderVariables();
        this.setMainSectionPaddingTopConditionally(this.headerGroup.offsetHeight)
      }

      this.lastScroll = currentScroll

      setTimeout(()=>{
        this.topPosition = Math.ceil(this.headerGroup.getBoundingClientRect().bottom)
        /*this.setMegaMenuTopPosition()*/
      }, 300)

      //this.setMobileMenuTopPosition()

    })


    this.addCustomerListeners();
  },

  addCustomerListeners() {
    window.addEventListener("openMobileMenu", this.openMobileMenu.bind(this));
    window.addEventListener("closeMobileMenu", this.closeMobileMenu.bind(this));
  },

  setHeaderVariables(resetAnnouncementBarHeight = false) {
    document.documentElement.style.setProperty('--header-height',
        `${this.headerGroup?.offsetHeight || 0}px`);
    resetAnnouncementBarHeight ?
        document.documentElement.style.setProperty('--announcement-height',
            `${0}px`) :
        document.documentElement.style.setProperty('--announcement-height',
            `${this.announcementBar?.offsetHeight || 0}px`)
  },


  openMobileMenu() {
    this.showMobileMenu = true
    document.querySelector("body").classList.add("overflow-hidden")
    if (this.body.style.overflow === "visible") {
      this.body.style.overflow = "hidden"
    }
  },


  setMainContainerMargin() {
    if (!this.announcementBarHeight){
      this.mainContainer.style.paddingTop = this.headerGroup.offsetHeight + 'px'
    }else{
      this.mainContainer.style.paddingTop = (this.headerGroup.offsetHeight + this.announcementBarHeight) + 'px'
    }
  },

  closeMobileMenu() {
    this.showMobileMenu = false
    this.closeSubmenu()
    this.closeThirdSubmenu()
    document.querySelector("body").classList.remove("overflow-hidden")
    this.body.style.overflow = "visible"
  },


  calculateHeaderWidth() {
    this.mainContainerWidth = this.mainContainer
    if (this.announcementBar){
      this.announcementBar.style.width = this.mainContainerWidth.offsetWidth + "px"
    }

    this.headerGroup.style.width = this.mainContainerWidth.offsetWidth + "px"
    this.megaMenuOverlay.style.width = this.mainContainerWidth.offsetWidth + "px"
    this.menuInner.forEach(element => {
      element.style.width = this.mainContainerWidth.offsetWidth + "px"
    })
  },
  preventBodyScroll() {
    document.querySelector("body").style.overflow = "scroll"
    document.querySelector("html").style.overflow = "hidden"
    document.querySelector("html").style.maxHeight = "100vh"
  },
  allowBodyScroll() {
    document.querySelector("body").style.overflow = ""
    document.querySelector("html").style.overflow = ""
    document.querySelector("html").style.maxHeight = ""
  },
  // openMegaMenu(event, handle, index, images){
  //   this.preventBodyScroll()
  //   this.showMegaMenu = true
  //   this.selectedMegaMenuHandle = handle
  //   this.selectedCollectionImage = images || null
  // },
  openMegaMenu(event, handle) {

    this.preventBodyScroll()
    this.selectedMegaMenuHandle = handle

    if (window.innerWidth >= 991) {
      if (handle) {
        const navigationItems = document.querySelectorAll('.main-navigation__item')

        if (navigationItems) {
          navigationItems.forEach(item => {
            item.classList.remove('mega-menu-open')
          })
        }

        this.selectedItem = event.target
        const selectedItem = this.selectedItem.querySelector('.main-navigation__item')
        if (selectedItem) {
          selectedItem.classList.add('mega-menu-open')
        }
        this.selectedHandle = event.target.querySelector(`[data-submenu]`).getAttribute("data-handle")
        this.showMegaMenu = true
      } else {
        this.showMegaMenu = false
        this.selectedHandle = null
        this.allowBodyScroll()
      }
      // this.selectActiveNavigationItem(event)
    }
  },
  setMegaMenuImage(image, event){
    event.stopPropagation()
    if (image){
      this.selectedCollectionImage = image
    }else{
      this.selectedCollectionImage = null
    }
  },


  /*openMegaMenu(event, handle) {

    this.preventBodyScroll()
    if (window.innerWidth >= 991) {
      if (handle) {
        const navigationItems = document.querySelectorAll('.main-navigation__item')

        if (navigationItems){
          navigationItems.forEach(item=>{
            item.classList.remove('mega-menu-open')
          })
        }

        this.selectedItem = event.target
        const selectedItem = this.selectedItem.querySelector('.main-navigation__item')
        if (selectedItem){
          selectedItem.classList.add('mega-menu-open')
        }
        this.selectedHandle = event.target.querySelector(`[data-submenu]`).getAttribute("data-handle")
        this.showMegaMenu = true
      } else {
        this.showMegaMenu = false
        this.selectedHandle = null
        this.allowBodyScroll()
      }
      this.selectActiveNavigationItem(event)
    }
  },*/
  closeMegaMenu(event) {
    if (window.innerWidth >= 991) {
      this.showMegaMenu = false
      this.selectedMegaMenuHandle = null
      this.allowBodyScroll()
      this.selectActiveNavigationItem(event)
    }
  },

  openSubmenu(event, handle) {
    this.showSubMenu = true
    this.selectedMobileHandle = event.target.getAttribute("data-handle") || event.currentTarget.closest('a').getAttribute("data-handle")
  },
  openThirdSubmenu(event, handle) {
    this.showThirdLevelSubMenu = true
    this.selectedThirdLevelMobileHandle = event.target.getAttribute("data-handle") || event.currentTarget.closest('a').getAttribute("data-handle")
    this.selectedThirdLevelMobileParentHandle = event.target.getAttribute("data-parent-handle") || event.currentTarget.closest('a').getAttribute("data-parent-handle")
  },
  closeSubmenu() {
    this.showSubMenu = false 
  },
  closeThirdSubmenu() {
    this.showThirdLevelSubMenu = false
  },
  setMegaMenuTopPosition() {
    this.menuInner.forEach(element => {
      element.style.top = this.topPosition + 'px'
    })
  },
  setMobileMenuTopPosition() {
    if (!this.body.classList.contains('scroll-down')){
      this.mobileOverlay.style.top = this.announcementBarHeight + 'px'
      this.mobileMenuBottomPanel.style.bottom = this.announcementBarHeight + 'px'

      this.mobileMenuWrapper.forEach(wrapper=>{
        wrapper.style.top = this.announcementBarHeight + 'px'
      })
    }else{
      this.mobileOverlay.style.top = 0
      this.mobileMenuBottomPanel.style.bottom = 0
      this.mobileMenuWrapper.forEach(wrapper=>{
        wrapper.style.top = 0
      })
    }
  },
  setMainSectionPaddingTopConditionally(height){
    if (this.pageTemplate !== "index" && !this.isHeaderTransparent){
      if (this.body.classList.contains('scroll-down')){
        this.mainContainer.style.paddingTop = height + 'px'
      }else{
        this.mainContainer.style.paddingTop = height + this.announcementBarHeight + 'px'
      }
    }
  },
  selectActiveNavigationItem(event){
    const selectedItemHeading = event.currentTarget.getAttribute("data-item-heading")
    this.navigationItems.forEach(item=>{
      item.style.opacity = "100%"
      item.classList.remove("inactive")
      const itemHeading = item.getAttribute("data-item-heading")

      if (itemHeading !== selectedItemHeading){
        item.classList.add("inactive")
        item.style.opacity = "60%"
      }
    })
  },
  resetNavigationItemsStyles(){
    this.navigationItems.forEach(item=>{
      item.classList.remove("inactive")
      item.style.opacity = "100%"
    })
  },
  openSearchBar(){
    this.OpenSearch = true
    if (this.searchInput){
      if (this.searchInput.value == ""){
        window.setTimeout(() => this.searchInput.focus(), 200);
      }
    }
  },
  closeSearchBar(){
    this.OpenSearch = false
    if (this.searchInput){
      this.searchInput.value = ""
    }
  },
  initMobileSearch() {
    const headerSection = document.querySelector('.section-header')
    if (headerSection) {
      const hideSearchbarMobile = headerSection.getAttribute('data-hide-searchbar-mobile') === 'true'
      const templateName = headerSection.getAttribute('data-template-name')
      const isIndexPage = templateName === 'index'
      
      this.hideSearchbarMobile = hideSearchbarMobile
      this.isIndexPage = isIndexPage
      
      // Visibility is now handled by CSS based on data attributes
      // We only need to set the mobileSearchVisible state for toggle functionality
      const mobileSearchContainer = document.getElementById('mobile-search-container')
      if (mobileSearchContainer) {
        // Check current visibility state (CSS handles the initial state)
        const isHidden = mobileSearchContainer.getAttribute('data-mobile-search-hidden') === 'true'
        const hideSetting = mobileSearchContainer.getAttribute('data-hide-searchbar-mobile') === 'true'
        const template = mobileSearchContainer.getAttribute('data-template-name')
        
        // Determine visibility based on CSS logic
        if (window.innerWidth <= 989) {
          this.mobileSearchVisible = !hideSetting || template === 'index' || !isHidden
        } else {
          this.mobileSearchVisible = true // Always visible on desktop
        }
      }

      // Only add event listeners if they don't already exist (prevent duplicate listeners)
      // Check if listeners are already attached
      if (mobileSearchContainer && !mobileSearchContainer.hasAttribute('data-listeners-attached')) {
        mobileSearchContainer.setAttribute('data-listeners-attached', 'true')
        
        // Prevent clicks inside the search container from closing it
        const stopPropagation = (e) => {
          e.stopPropagation()
        }
        
        // Add event listeners to prevent clicks inside from bubbling up
        mobileSearchContainer.addEventListener('click', stopPropagation, true)
        mobileSearchContainer.addEventListener('touchstart', stopPropagation, true)
        mobileSearchContainer.addEventListener('touchend', stopPropagation, true)
        
        // Also prevent clicks on the input field specifically
        const searchInput = mobileSearchContainer.querySelector('#Search-In-Modal')
        if (searchInput) {
          // For input, only stop propagation, don't prevent default (to allow focus)
          const inputStopPropagation = (e) => {
            e.stopPropagation()
            e.stopImmediatePropagation()
            // Mark the event so toggleMobileSearch knows to ignore it
            e.target.setAttribute('data-search-input-click', 'true')
            setTimeout(() => {
              if (e.target) e.target.removeAttribute('data-search-input-click')
            }, 100)
          }
          
          searchInput.addEventListener('click', inputStopPropagation, true)
          searchInput.addEventListener('touchstart', inputStopPropagation, true)
          searchInput.addEventListener('touchend', inputStopPropagation, true)
          searchInput.addEventListener('focus', inputStopPropagation, true)
          searchInput.addEventListener('focusin', inputStopPropagation, true)
          
          // Prevent the input from triggering toggle when clicked
          searchInput.addEventListener('mousedown', inputStopPropagation, true)
          searchInput.addEventListener('pointerdown', inputStopPropagation, true)
          
          // Also prevent the form and field from bubbling
          const form = searchInput.closest('form')
          const field = searchInput.closest('.field')
          if (form && !form.hasAttribute('data-listeners-attached')) {
            form.setAttribute('data-listeners-attached', 'true')
            form.addEventListener('click', stopPropagation, true)
            form.addEventListener('touchstart', stopPropagation, true)
          }
          if (field && !field.hasAttribute('data-listeners-attached')) {
            field.setAttribute('data-listeners-attached', 'true')
            field.addEventListener('click', stopPropagation, true)
            field.addEventListener('touchstart', stopPropagation, true)
          }
        }
      }
    }
  },
  toggleMobileSearch(event) {
    // Prevent toggling if we're in the middle of opening
    if (this.isOpeningMobileSearch) {
      return
    }
    
    if (event) {
      const mobileSearchContainer = document.getElementById('mobile-search-container')
      const searchInput = document.getElementById('Search-In-Modal')
      
      // Check if the input was just clicked (has the marker attribute)
      if (searchInput && searchInput.hasAttribute('data-search-input-click')) {
        return
      }
      
      // Prevent toggling if clicking inside the search container or on the input
      if (mobileSearchContainer && (
        mobileSearchContainer.contains(event.target) ||
        event.target.closest('#mobile-search-container') ||
        event.target.id === 'Search-In-Modal' ||
        event.target.closest('#Search-In-Modal') ||
        event.target.closest('input') ||
        event.target.closest('form') ||
        event.target.closest('button') ||
        event.target.closest('.field') ||
        event.target.closest('.search-modal__form')
      )) {
        return
      }
      
      // Also check if clicking on the input specifically
      if (searchInput && (
        event.target === searchInput ||
        event.target.closest('#Search-In-Modal') ||
        searchInput.contains(event.target)
      )) {
        return
      }
    }
    
    const mobileSearchContainer = document.getElementById('mobile-search-container')
    if (mobileSearchContainer) {
      const isHidden = mobileSearchContainer.getAttribute('data-mobile-search-hidden') === 'true'
      
      if (isHidden) {
        // Set flag to prevent immediate closing
        this.isOpeningMobileSearch = true
        mobileSearchContainer.setAttribute('data-mobile-search-hidden', 'false')
        this.mobileSearchVisible = true
        
        // Clear the flag after a short delay
        setTimeout(() => {
          this.isOpeningMobileSearch = false
        }, 300)
      } else {
        // Don't close on index page (CSS always shows it there)
        const templateName = mobileSearchContainer.getAttribute('data-template-name')
        if (templateName === 'index') {
          return
        }
        
        // Only close if not clicking on the input itself or inside search container
        const searchInput = document.getElementById('Search-In-Modal')
        if (event && searchInput && (
          event.target === searchInput || 
          event.target.closest('#Search-In-Modal') ||
          event.target.closest('#mobile-search-container')
        )) {
          return
        }
        mobileSearchContainer.setAttribute('data-mobile-search-hidden', 'true')
        this.mobileSearchVisible = false
      }
    }
  }
})

export default psnNavigation

document.addEventListener("alpine:init", () => {
  Alpine.data("psnNavigation", psnNavigation);
})
